import React from "react";
import DirectoryTable from "@/components/DirectoryTable";
import { useAuth } from "@/context/AuthContext";
import { hasRole } from "@/lib/utils";

const FIELDS = [{ name: "name", label: "Software / Framework Name", required: true }];
const COLUMNS = [{ key: "name", label: "Software / Framework" }];

export default function AdminSoftware() {
  const { user } = useAuth();
  return (
    <DirectoryTable
      title="Software / Frameworks Catalog"
      description="Options offered on the 'Software / Frameworks Required' multi-select in Step 2."
      endpoint="/software-catalog"
      columns={COLUMNS}
      fields={FIELDS}
      canWrite={hasRole(user)}
    />
  );
}
